import { Store } from 'hooks/useStore'
import { INITIAL } from '../constants'

export const characterStore = new Store(INITIAL.VALUES)